import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alignments-dashboard',
  templateUrl: './alignments-dashboard.component.html',
  styleUrls: ['./alignments-dashboard.component.scss']
})
export class AlignmentsDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
